import type { Business } from "@/schemas";
import { BusinessProfileResponseSchema, BusinessSchema } from "@/schemas";
import { z } from "zod";

import { apiRequest, apiRequestFormData } from "./apiUtils";

export async function getBusiness(userId: string): Promise<Business> {
  const data = await apiRequest<unknown>(`business/${userId}`, {
    method: "GET",
  });
  return BusinessSchema.parse(data);
}

export async function getBusinessProfile() {
  const data = await apiRequest<unknown>(`business/info`, {
    method: "GET",
  });
  return BusinessProfileResponseSchema.parse(data);
}

export async function updateBusinessProfile(business: Partial<Business>) {
  const data = await apiRequest<unknown>(`business/update`, {
    method: "PATCH",
    body: JSON.stringify(business),
  });
  return BusinessProfileResponseSchema.parse(data);
}

export async function uploadBusinessImage(file: File): Promise<void> {
  const formData = new FormData();
  formData.append("image", file);
  await apiRequestFormData(`business/image`, formData);
}

// Stripe Connect Status
export const StripeConnectStatusSchema = z.object({
  stripeConnectAccountId: z.string().nullable(),
  stripeConnectOnboardingStatus: z.enum(['not_started', 'in_progress', 'completed', 'failed']),
  stripeConnectAchVerified: z.boolean(),
  stripeConnectCreatedAt: z.string().datetime().nullable(),
  stripeConnectCompletedAt: z.string().datetime().nullable(),
});

export type StripeConnectStatus = z.infer<typeof StripeConnectStatusSchema>;

export async function getStripeConnectStatus(businessId: string): Promise<StripeConnectStatus> {
  const data = await apiRequest<unknown>(`business/${businessId}/stripe-connect/status`, {
    method: "GET",
  });
  return StripeConnectStatusSchema.parse(data);
}
